module.exports = __webpack_public_path__ + "img/8.b18329c6.jpg";